import {useEventSource} from '@vueuse/core/index';
import {watch, ref} from 'vue';
import {useStore} from 'vuex';
import http from '../http';

export function useNotifications() {
  const isStarted = ref(false);
  const store = useStore();

  const startListening = () => {
    if (isStarted.value) {
      return;
    }

    const {status, data, error, close} = useEventSource('/api/notifications/sse', ['notifications'], {withCredentials: true});

    watch(() => data.value, async () => {
      const notifications = JSON.parse(data.value);

      for (const [,notification] of Object.entries(notifications.messages)) {
        await store.dispatch('notifications/addNotification', notification)
      }
    });

    watch(() => status.value, () => {
      if (status.value === 'CLOSED') {
        isStarted.value = false;
      }
    })

    return {
      status, data, error, close
    }
  }

  const getNotifications = () => http.get('/api/notifications');
  const getNotificationsAndStoreIt = async () => await store.dispatch('notifications/setNotifications', (await getNotifications()).data)
  const markAsRead = (id) => http.post('/api/notifications/' + id)
  const markAllAsRead = (id) => http.post('/api/notifications/')

  return {
    startListening,
    getNotificationsAndStoreIt,
    markAsRead,
    markAllAsRead,
  }
}
